import { useState } from "react";
import { User } from "iconsax-react";

type AvatarProps = {
  src?: string;
  alt?: string;
};

export default function Avatar({ src, alt }: AvatarProps) {
  const [imgError, setImgError] = useState(false);

  if (!src || imgError) {
    return (
      <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
        <User color="#111111" size={20} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt || "User avatar"}
      className="w-8 h-8 rounded-full object-cover"
      onError={() => setImgError(true)}
    />
  );
}
